export enum AlbumType {
    none = 'none',
    new = 'new'
}

export interface ILoadingBar {
    show: boolean;
}
